module.exports = __webpack_public_path__ + "img/img26s.92971807.png";